import { Navigate, Route, Routes } from 'react-router-dom';
import { AppLayout } from '../shared/layout/AppLayout';
import { PlatformLayout } from '../shared/layout/PlatformLayout';
import { RequireAuth } from '../shared/layout/RequireAuth';
import { RequirePlatformAuth } from '../shared/layout/RequirePlatformAuth';
import { LoginPage } from '../pages/LoginPage';
import { DashboardPage } from '../pages/DashboardPage';
import { UsersPage } from '../pages/UsersPage';
import { ParkingsPage } from '../pages/ParkingsPage';
import { CustomersPage } from '../pages/CustomersPage';
import { VehiclesPage } from '../pages/VehiclesPage';
import { SessionsPage } from '../pages/SessionsPage';
import { TariffsPage } from '../pages/TariffsPage';
import { InvoicesPage } from '../pages/InvoicesPage';
import { SettingsPage } from '../pages/SettingsPage';
import { ReservationsPage } from '../pages/ReservationsPage';
import { IncidentsPage } from '../pages/IncidentsPage';
import { MaintenancePage } from '../pages/MaintenancePage';
import { EmployeesPage } from '../pages/EmployeesPage';
import { BarriersPage } from '../pages/BarriersPage';
import { ReportsPage } from '../pages/ReportsPage';
import { AlprPage } from '../pages/AlprPage';
import { MatriculasPage } from '../pages/MatriculasPage';
import { VigilanciaPage } from '../pages/VigilanciaPage';
import { PlatformLoginPage } from '../pages/PlatformLoginPage';
import { PlatformDashboardPage } from '../pages/PlatformDashboardPage';
import { PlatformTenantsPage } from '../pages/PlatformTenantsPage';
import { PlatformSettingsPage } from '../pages/PlatformSettingsPage';

export function AppRouter() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/platform/login" element={<PlatformLoginPage />} />

      <Route element={<RequirePlatformAuth />}>
        <Route element={<PlatformLayout />}>
          <Route path="/platform" element={<PlatformDashboardPage />} />
          <Route path="/platform/tenants" element={<PlatformTenantsPage />} />
          <Route path="/platform/settings" element={<PlatformSettingsPage />} />
        </Route>
      </Route>

      <Route element={<RequireAuth />}>
        <Route element={<AppLayout />}>
          <Route path="/" element={<DashboardPage />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/users" element={<UsersPage />} />
          <Route path="/parkings" element={<ParkingsPage />} />
          <Route path="/customers" element={<CustomersPage />} />
          <Route path="/vehicles" element={<VehiclesPage />} />
          <Route path="/sessions" element={<SessionsPage />} />
          <Route path="/tariffs" element={<TariffsPage />} />
          <Route path="/invoices" element={<InvoicesPage />} />
          <Route path="/reservations" element={<ReservationsPage />} />
          <Route path="/incidents" element={<IncidentsPage />} />
          <Route path="/maintenance" element={<MaintenancePage />} />
          <Route path="/employees" element={<EmployeesPage />} />
          <Route path="/barriers" element={<BarriersPage />} />
          <Route path="/alpr" element={<AlprPage />} />
          <Route path="/matriculas" element={<MatriculasPage />} />
          <Route path="/vigilancia" element={<VigilanciaPage />} />
          <Route path="/reports" element={<ReportsPage />} />
          <Route path="/settings" element={<SettingsPage />} />
        </Route>
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
